// TODO: Needs to be kept in sync with
// `src/pages/Prototype/styles/_breakpoints.scss`
// until we can solve for a single source of truth:
// https://github.com/tari-labs/yatui/issues/11
export const breakpoints = {
    phablet: 480,
    tablet: 768,
    desktop: 1064,
    widescreen: 1366,
    quadHdY: 1440,
    ultrawide: 1920,
};

// Consider these "height" breakpoints:
// shd: 720,
// fhd: 1080,
// qhd: 1440,
// uhd: 2160
